import React from "react";
import { Chip } from "@mui/material";

export const getStatusChipColor = (status) => {
  switch (status?.toLowerCase()) {
    case "interested":
      return "primary";
    case "active":
      return "info";
    case "hired":
      return "success";
    case "inactive":
      return "error";
    case "rejected":
      return "error";
    case "offer declined":
        return "error";
    case "offer extended":
      return "warning";
    case "blocked":
      return "error";
    case "engaged":
      return "primary";
    case "interview":  // New case added for interview
      return "secondary";  // Specify your desired color here
    default:
      return "default";
  }
};

const StatusChip = ({ status }) => {
  return (
    <Chip
      label={status}
      color={getStatusChipColor(status)}
      sx={{
        textTransform: "capitalize",
        borderRadius: "5px", // Custom border-radius
        height: 30, 
        width: 120,
        fontSize: 12,
        fontFamily: "Urbane-Light",
        justifyContent: "center", // Center the text inside the chip
      }}
    />
  );
};

export default StatusChip;
